// Single source of truth for the roles a user_roles row can hold.
// A user can have more than one (user_roles.roles is a TEXT[]) — see
// supabase/migrations/20260809b_user_roles_multi_role.sql.
export const ROLES = ['ADMIN', 'OPERATIONS', 'ACCOUNTS', 'SALES', 'VIEWER'] as const

export type UserRole = (typeof ROLES)[number]

// Mirrors the SQL has_any_role() function: true if userRoles overlaps allowed.
export function hasAnyRole(userRoles: string[] | null | undefined, allowed: string[]): boolean {
  if (!userRoles) return false
  return userRoles.some(r => allowed.includes(r))
}
